import { useContext } from 'react';

import { DevModalContext, type DevModalContextType } from '~/components/DevModal/DevModalContext';

/**
 * Hook to access dev modal functionality from components.
 */
export const useDevModal = (): DevModalContextType => {
  const context = useContext(DevModalContext);

  if (!context) {
    // Return default values when not within provider context
    return {
      isDevModalOpen: false,
      openDevModal: () => {},
      closeDevModal: () => {},
      shouldShowDevButton: false,
      devFlagOverrideKey: 0,
      registerDevFlagListener: () => () => {}, // Return a no-op unregister function
    };
  }

  return context;
};
